import { AudioManager } from './../../../managers/AudioManager';
import { GameConstants } from "../../../GameConstants";
import { GameVars } from "../../../GameVars";

export class CardsContainer extends Phaser.GameObjects.Container {

    private cards: Phaser.GameObjects.Image[];
    private frames: Phaser.GameObjects.Image[];

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;

        this.scaleX = GameVars.scaleX;
        
        this.y = 335;

        this.cards = [];
        this.frames = [];

        for (let i = 0; i < 5; i++) {

            let mark = new Phaser.GameObjects.Image(this.scene, (i - 2) * 70, 0, "texture_atlas_1", "mark_card.png");
            this.add(mark);
        }

        this.visible = false;
    }

    public addCardsFrames(cards: any[]): void {

        for (let i = 0; i < this.cards.length; i++) {
            for (let j = 0; j < cards.length; j++) {
                if (this.cards[i].name === (cards[j].value + cards[j].suit)) {

                    const px = (i - 2) * 70;

                    const card = new Phaser.GameObjects.Image(this.scene, px, 0, "texture_atlas_1", "frame_winner_hand.png");
                    card.setScale(.75);
                    this.add(card);
                    this.frames.push(card);
                }
            }
        }
    }

    public dealCard(cardId: string, delay: number): void {
        
        const i = this.cards.length;

        const px = (i - 2) * 70;
        const frameName = GameVars.cardFrameName(cardId) + ".png";

        const card = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_2", "card-back.png");
        card.setScale(.75);
        card.tint = 0xEFFFEF;
        card.name = cardId;
        card.alpha = 0;
        this.add(card);
        this.cards.push(card);

        this.scene.tweens.add({
            targets: card,
            alpha: 1,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 150 / GameVars.gameSpeed,
            delay: delay / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: card,
            scaleX: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 150 / GameVars.gameSpeed,
            delay: delay / GameVars.gameSpeed,
            onComplete: () => {
                if (GameVars.allin) {
                    if (i === 4) {
                        AudioManager.playSound("all_in_last_card_reveal_win");
                    } else {
                        AudioManager.playSound("all_in_card_reveal");
                    }
                } else {
                    AudioManager.playSound("card_reveal_" + (Math.floor(Math.random() * 3) + 1));
                }
                
                card.setFrame(frameName);
            },
            onCompleteScope: this
        });

        this.scene.tweens.add({
            targets: card,
            scaleX: .75,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 150 / GameVars.gameSpeed,
            delay: (delay + 150) / GameVars.gameSpeed
        });

        this.scene.tweens.add({
            targets: card,
            x: px,
            ease: Phaser.Math.Easing.Quadratic.Out,
            duration: 300 / GameVars.gameSpeed,
            delay: delay / GameVars.gameSpeed
        });
    }

    public resetTable(): void {

        this.scene.tweens.add({
            targets: this.cards,
            alpha: 0,
            ease: Phaser.Math.Easing.Cubic.Out,
            duration: 250 / GameVars.gameSpeed,
            onComplete: () => {
                for (let i = 0; i < this.cards.length; i++) {
                    this.remove(this.cards[i]);
                }
                this.cards = [];
            },
            onCompleteScope: this
        });

        for (let i = 0; i < this.frames.length; i++) {
            this.remove(this.frames[i]);
        }
        this.frames = [];
    }
}
